import React, {  useRef, useEffect, useContext } from "react";
import Select from "react-select";
import themeContext from "../../context/theme/ThemeContext";
import { constantStyleForSelect } from "../CustomSelect";
import { getIn } from 'formik';

const FormikSelectField = ({ field, form, options, isMulti = false, ...props }) => {
  const { getThemeColor } = useContext(themeContext);
  const selectRef = useRef(null);

  useEffect(() => {
    if (props.autoFocus && selectRef.current) {
      selectRef.current.focus();
    }
  }, [props.autoFocus]);

  // Ensure `onChange` sets a valid value
  const onChange = (selectedOption) => {
    const value = isMulti
    ? (Array.isArray(selectedOption) ? selectedOption.map(option => option.key) : [])
    : (selectedOption?.key ?? "");
    form.setFieldValue(field.name, value);
  };

  const errorMessage = getIn(props.allErrors, field.name);

  // Ensure `value` is never undefined
  const value = isMulti
  ? (Array.isArray(field.value) ? options.filter(option => field.value.includes(option.key)) : [])
  : (options.find(option => option.key === field.value) ?? null);

  return (
    <>
      <Select
        ref={selectRef}
        name={field.name}
        placeholder={props.placeholder}
        classNamePrefix="react-select"
        styles={constantStyleForSelect(getThemeColor)}
        options={options}
        isMulti={isMulti}
        value={value}  // Ensured non-undefined value
        onChange={onChange}
        onBlur={() => form.setFieldTouched(field.name, true)}
        autoFocus={props.autoFocus || false}
      />
      {errorMessage && (
        <span id={`${field.name}-errors`}>
          <div role="alert">
            <p className="error-message"><span>{errorMessage}</span></p>
          </div>
        </span>
      )}
    </>
  );
};

export default FormikSelectField;
